import Lazyload from 'vue-lazyload';
export default Lazyload;


//////////////////
// WEBPACK FOOTER
// ./~/_vant@2.13.9@vant/es/lazyload/index.js
// module id = 707
// module chunks = 49